import { render, staticRenderFns } from "./verSoporte.vue?vue&type=template&id=16f7ad41&scoped=true"
import script from "./verSoporte.vue?vue&type=script&lang=js"
export * from "./verSoporte.vue?vue&type=script&lang=js"
import style0 from "./verSoporte.vue?vue&type=style&index=0&id=16f7ad41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f7ad41",
  null
  
)

export default component.exports